exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".event-detail .copy-btn-wrapper {\n  position: relative;\n  top: 4.3rem;\n  right: 2px;\n  z-index: 1000;\n  float: right; }\n\n.event-detail .copy-btn {\n  border: none;\n  background-color: transparent; }\n  .event-detail .copy-btn:hover {\n    color: #23527c; }\n", ""]);

